import { ReactComponent as MoonIcon } from './Moon.svg';
import { ReactComponent as SunIcon } from './Sun.svg';
import { ReactComponent as ResumeIcon } from './Resume.svg';
import { ReactComponent as GithubIcon } from './Github.svg';
import { ReactComponent as LinkedInIcon } from './Icons.svg';
import { ReactComponent as JavaScriptIcon } from './JavaScript.svg';
import { ReactComponent as CssIcon } from './Css.svg';
import { ReactComponent as ReactIcon } from './React.svg';
import { ReactComponent as ReduxIcon } from './Redux.svg';
import { ReactComponent as HtmlIcon } from './Html.svg';
import { ReactComponent as NextIcon } from './Next.svg';
import { ReactComponent as PhpIcon } from './Php.svg';
import { ReactComponent as TailwindIcon } from './Tailwind.svg';
import { ReactComponent as BashIcon } from './Bash.svg';
import { ReactComponent as JsonIcon } from './Json.svg';
import { ReactComponent as PostmanIcon } from './Postman.svg';
import { ReactComponent as DockerIcon } from './Docker.svg';
import { ReactComponent as WordpressIcon } from './Wordpress.svg';
import { ReactComponent as KotlinIcon } from './Kotlin.svg';
import { ReactComponent as MariaDbIcon } from './Mariadb.svg';
import { ReactComponent as PhpMyAdminIcon } from './PhpMyAdmin.svg';
import { ReactComponent as PostgreSqlIcon } from './PostgreSql.svg';
import { ReactComponent as ExpressIcon } from './Express.svg';
import { ReactComponent as AngleUpIcon } from './angle-up.svg';
import { ReactComponent as AngleDownIcon } from './angle-down.svg';
import { ReactComponent as ArrowUpIcon } from './arrow-up.svg';
import { ReactComponent as HorizontalLineIcon } from './horizontal-rule.svg';

const brandColors = {
    JavaScriptIcon: '#F7DF1E',
    CssIcon: '#663399',
    ReactIcon: '#61DAFB',
    ReduxIcon: '#764ABC',
    GithubIcon: '#000000',
    HtmlIcon: '#E34F26',
    NextIcon: '#000000',
    PhpIcon: '#777BB4',
    TailwindIcon: '#06B6D4',
    BashIcon: '#4EAA25',
    JsonIcon: '#000000',
    PostmanIcon: '#FF6C37',
    DockerIcon: '#2496ED',
    WordpressIcon: '#21759B',
    KotlinIcon: '#7F52FF',
    MariaDbIcon: '#003545',
    PhpMyAdminIcon: '#6C78AF',
    PostgreSqlIcon: '#4169E1',
    ExpressIcon: '#000000',
};

export {
    MoonIcon,
    SunIcon,
    ResumeIcon,
    GithubIcon,
    LinkedInIcon,
    JavaScriptIcon,
    CssIcon,
    ReactIcon,
    ReduxIcon,
    HtmlIcon,
    NextIcon,
    PhpIcon,
    TailwindIcon,
    BashIcon,
    JsonIcon,
    PostmanIcon,
    DockerIcon,
    WordpressIcon,
    KotlinIcon,
    MariaDbIcon,
    PhpMyAdminIcon,
    PostgreSqlIcon,
    ExpressIcon,
    AngleUpIcon,
    AngleDownIcon,
    ArrowUpIcon,
    HorizontalLineIcon,
    brandColors,
}

